"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_ASSIGNMENTS = 'CONTEXT_ASSIGNMENTS';
exports.context = function (contextName) {
    return function (prototype, propName) {
        if (!prototype[exports.CONTEXT_ASSIGNMENTS]) {
            prototype[exports.CONTEXT_ASSIGNMENTS] = [];
        }
        prototype[exports.CONTEXT_ASSIGNMENTS].push({
            propName: propName,
            contextName: contextName
        });
    };
};
//# sourceMappingURL=context.js.map